import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../environments/environment';
import { saveAs } from 'file-saver';

import { ProductTypeResponseInterface } from '../../interfaces/product-type-response.interface';
import { HttpClient } from '@angular/common/http';
import { NovedadData } from '../../interfaces/novedad-response.interface';
import Swal from 'sweetalert2';
import { RegistroService } from '../registro.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { map } from 'lodash';

@Component({
    selector: 'app-report-no-ventas',
    templateUrl: './report-filter-semester-dev.component.html',
    styleUrls: ['./report-filter-semester-dev.component.css'],
})
export class ReportFilterSemesterDevComponent {
    startDate: any;
    endDate: any;
    dataLoaded = false;
    novedadData: NovedadData[] = [];
    endDateHasError: boolean = false;
    semester: { value: number; name: string }[] = [
        { value: 1, name: 'Enero a Junio' },
        { value: 2, name: 'Julio a Diciembre' },
    ];
    semestreNombre: string;

    private apiUrl: string = environment.apiSiriUrl;
    constructor(
        private router: Router,
        private http: HttpClient,
        private registroService: RegistroService,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    toConsult() {
        // const endDatePlusOne = new Date(this.endDate);
        // endDatePlusOne.setDate(endDatePlusOne.getDate() + 1);

        this.http
            .get<
                NovedadData[]
            >(`${this.apiUrl}novedad/historicos?fechaInicio=${this.startDate}&fechaFin=${this.endDate}&agenteVigiladoID=${this.registroService.empresaSelected}`)
            .subscribe(
                (response) => {
                    /* console.log(" reports response ", response); */
                    this.novedadData = response.map((item) => ({
                        ...item,
                        semestreNombre:
                            this.semester.find((s) => s.value === item.semestre)
                                ?.name || 'Semestre no definido',
                    }));
                    this.dataLoaded = true;
                },
                (error) => {
                    console.error('Error', error);
                }
            );
    }

    exportData() {
        // Formatear fechas a YYYY-MM-DD
        // const startDateStr = moment(this.startDate).format('YYYY-MM-DD');
        // const endDateStr = moment(this.endDate).format('YYYY-MM-DD');

        this.http
            .get(
                `${this.apiUrl}novedad/exportar-cargue-historicos?fechaInicio=${this.startDate}&fechaFin=${this.endDate}&agenteVigiladoID=${this.registroService.empresaSelected}`,
                { responseType: 'blob' }
            )
            .subscribe(
                (response) => {
                    saveAs(response, 'novedad.xlsx');
                },
                (error) => {
                    console.error('Error en descarga:', error);
                    // Mostrar mensaje de error al usuario
                    if (error.status === 400) {
                        alert(error.error.message);
                    } else {
                        alert('Error al descargar el archivo');
                    }
                }
            );
    }
    /*  isValidDates(): boolean {
    const invalid = this.startDate && this.endDate && this.startDate <= this.endDate
    if (invalid) {
      swal.fire({
        title: 'Error',
        text: 'La fecha de inicio no puede ser mayor a la fecha final',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
      }
    return this.startDate && this.endDate && this.startDate <= this.endDate;

  }*/

    mostrarTexto() {
        this.translate
            .get('novedadHistoricos.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    getYear(date: Date): number {
        return date.getFullYear();
    }

    getMonth(date: Date): number {
        return date.getMonth() + 1;
    }

    /**
     * Maneja el evento cuando el usuario selecciona la fecha inicial.
     * También establece la fecha final automáticamente igual a la inicial.
     *
     * @param date Fecha seleccionada en formato YYYY-S.
     */
    onStartDateSelected(date: string) {
        this.startDate = date;
        this.endDate = this.startDate;
    }

    /**
     * Maneja el evento cuando el usuario selecciona la fecha final.
     * Valida que el semestre final sea mayor o igual al inicial.
     *
     * @param date Fecha seleccionada en formato YYYY-S.
     */
    onEndDateSelected(date: string) {
        if (!this.isSemesterBeforeCurrent(date)) {
            this.endDate = date;
            this.endDateHasError = true;
            this.showAlertError(
                'Solo puedes consultar semestres anteriores al actual'
            );
            return;
        }

        // Si no hay fecha inicial, aceptar cualquier fecha final
        if (!this.startDate) {
            this.endDate = date;
            this.endDateHasError = false;
            return;
        }

        // Compara semestres
        const comparacion = this.compareSemesters(date, this.startDate);

        if (comparacion >= 0) {
            // Semestre final es mayor o igual al inicial - válido
            this.endDate = date;
            this.endDateHasError = false;
        } else {
            // Semestre final es menor al inicial - mostrar error
            this.endDate = date;
            this.endDateHasError = true;
            this.showAlertError(
                'El semestre final debe ser mayor o igual al semestre inicial'
            );
        }
    }

    /**
     * Compara dos semestres en formato YYYY-S
     * Retorna:
     *   -1 si semestre1 < semestre2,
     *    0 si semestre1 = semestre2,
     *    1 si semestre1 > semestre2
     */
    compareSemesters(startDate: string, endDate: string): number {
        if (!startDate || !endDate) return 0;

        const [year1, semester1] = startDate.split('-').map(Number);
        const [year2, semester2] = endDate.split('-').map(Number);

        // Compara años
        if (year1 < year2) return -1;
        if (year1 > year2) return 1;

        // Mismo año, compara semestres (1 < 2)
        if (semester1 === 1 && semester2 === 2) return -1;
        if (semester1 === 2 && semester2 === 1) return 1;

        return 0; // Mismo semestre
    }

    /**
     * Muestra mensaje de error
     */
    showAlertError(message: string) {
        Swal.fire({
            title: 'Error',
            text: message,
            icon: 'error',
            confirmButtonText: 'Aceptar',
        });
    }

    /**
     * Valida si un semestre es anterior al semestre actual
     *
     * @param semester - Semestre en formato YYYY-S (ej: '2025-1', '2026-2')
     * @returns true si el semestre es anterior al actual, false en caso contrario
     *
     * @example
     * // Si estamos en Junio 2026 (Semestre 1)
     * isSemesterBeforeCurrent('2025-2') // true
     * isSemesterBeforeCurrent('2026-1') // false (es el actual)
     * isSemesterBeforeCurrent('2026-2') // false (es futuro)
     * isSemesterBeforeCurrent('2027-1') // false (año futuro)
     */
    private isSemesterBeforeCurrent(semester: string): boolean {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const currentSemester = currentMonth <= 6 ? 1 : 2;

        const [yearStr, semesterStr] = semester.split('-');
        const year = parseInt(yearStr);
        const semesterNum = parseInt(semesterStr);

        if (year < currentYear) return true;
        if (year === currentYear) return semesterNum < currentSemester;
        return false;
    }
}
